import { render, staticRenderFns } from "./color-defaultValue-editor.vue?vue&type=template&id=2106db2e&scoped=true&"
import script from "./color-defaultValue-editor.vue?vue&type=script&lang=js&"
export * from "./color-defaultValue-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2106db2e",
  null
  
)

export default component.exports